export default __webpack_public_path__ + "static/media/visibility-on-icon.e8932900.svg";